import { render } from "./IconDropDown.vue?vue&type=template&id=0bec3b4f"
import script from "./IconDropDown.vue?vue&type=script&lang=js"
export * from "./IconDropDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconDropDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bec3b4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bec3b4f', __exports__)) {
    api.reload('0bec3b4f', __exports__)
  }
  
  module.hot.accept("./IconDropDown.vue?vue&type=template&id=0bec3b4f", () => {
    api.rerender('0bec3b4f', render)
  })

}


export default __exports__